import { css } from '@emotion/react'
import { Color, Spacing, Typography } from '@opallabs/gem'
import { fontSizes } from '@opallabs/pulsar'

const headingContainer = css({
  alignItems: 'center',
  display: 'flex',
})

const headingText = ({
  theme,
  hasIcon,
}: {
  theme: 'light' | 'dark'
  hasIcon: boolean
}) =>
  css({
    color: Color[theme].Text.Default,
    ...Typography.T300,
    fontSize: fontSizes.small,
    marginBlock: Spacing.XS / 4,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    inlineSize: Spacing.M * 11.875,
    marginInline: hasIcon ? Spacing.XS : 0,
    lineHeight: 1,
  })

export const styles = {
  headingContainer,
  headingText,
}
